<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>主体编号</th>
						<td>{{ detailInfo.behaviorCode }}</td>
						<th>备注</th>
						<td>{{ detailInfo.remark }}</td>
					</tr>
					<tr>
						<th>内容描述</th>
						<td colspan="3">{{ detailInfo.behaviorContent }}</td>
					</tr>
					<tr>
						<th>登记部门</th>
						<td>{{ detailInfo.depart }}</td>
						<th>登记时间</th>
						<td>{{ detailInfo.makeTime | formatDate }}</td>
					</tr>
				</table>
			</div>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-if="isVip"></nonbind-vip>
			<!-- 未开通超级会员提示 -->
			<nonbind-svip v-if="isSVip"></nonbind-svip>
		</div>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { personBehaviorRecordGetById, getPersonWarningDetail } from '@/api/qualificationQuery/person'

	// 黑名单联合惩戒详情
	export default {
		name: 'BlacklistPunishment',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			},
			// 表示是否是资质宝风险提醒
			isRisk: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				detailInfo: {
					// 主体编号
					behaviorCode: '',
					// 内容描述
					behaviorContent: '',
					// 登记部门
					depart: '',
					// 登记时间
					makeTime: '',
					// 备注
					remark: ''
				},
				message: '',
				isVip: false,
				isSVip: false
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			if (this.isRisk) {
				this.getRiskBehaviorDetail()
			} else {
				this.initDetail()
			}
		},
		methods: {
			initDetail() {
				this.loading = true
				const params = {
					personBehaviorId: this.id
				}
				personBehaviorRecordGetById(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.detailInfo = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},

			// 获取资质宝风险提醒关于个人的黑名单及联合惩戒详情
			getRiskBehaviorDetail() {
				this.loading = true
				const params = {
					personBehaviorId: this.id
				}

				getPersonWarningDetail(params)
					.then(response => {
						const { data } = response

						if (data) {
							this.detailInfo = data
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
